/**
 * Constantes para chaves de localStorage e sessionStorage
 */

export const STORAGE_KEYS = {
  // Session Storage
  PENDING_ROUTE: 'pending_route',
  QUERY_PARAM_CID: 'query_param_cid',
  
  // Local Storage
  BANNER_CLOSED: 'vivo_data_rewards_banner_closed',
  USER_DATA: 'user_data',
  TOKEN: 'token',
} as const;
